import { render, staticRenderFns } from "./deductions_item.vue?vue&type=template&id=9e187d3e"
import script from "./deductions_item.vue?vue&type=script&lang=js"
export * from "./deductions_item.vue?vue&type=script&lang=js"
import style0 from "./deductions_item.vue?vue&type=style&index=0&id=9e187d3e&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports